<template>
    <div>
        <a href="#" @click="$bvModal.show('itinerary-modal')" class="btn btn-itg-dark btn-block">
            <i class="fa fa-calendar mr-1"></i>
            View Itinerary
        </a>
        <itinerary-modal></itinerary-modal>
    </div>
</template>

<script>
    import ItineraryModal from "./ItineraryButtonAndModal/ItineraryModal";

    export default {
        name: "ItineraryButtonAndModal",
        components: {ItineraryModal},
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped>

</style>
